
// Db Status
export const SpecimenError = "Error";

// Sample Status
export const Received = "Received";